import { Button, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { motion } from "framer-motion";
import { Star } from "@mui/icons-material";
import VooningLogo from "../assests/vooning_logo_tm.png"
import FashionWorldLogo from "../assests/fashion_world.png"
import zebra_club from "../assests/zebra_club.png"
import Reena_Sharma from "../assests/reena_sharma.jpeg";

const TopIndustry = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(450));


    const styles = {
        container: {
            textAlign: 'center',
            background: '#000',
            paddingBottom: isMobile ? 50 : 100,
            boxSizing: 'border-box'
        },
        headingText: {
            fontSize: isMobile ? 20 : '35px',
            fontWeight: 700,
            color: '#fff',
        },
        industryBox: {
            width: '95%',
            backgroundColor: '#fff',
            padding: isSmall ? '10px' : '40px',
            boxSizing: 'border-box',
            borderRadius: 20,
            display: 'grid',
            gridTemplateColumns: isSmall ? 'repeat(3, 1fr)' : isMobile ? 'repeat(4, 1fr)' : 'repeat(6, 1fr)',
            gap: '10px',
            alignItems: 'stretch',
        },
        gridItem: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: 'auto',
        },
        image: {
            width: isMobile ? '80%' : '60%',
        },
        socialContainer: {
            marginTop: 40,
            display: 'flex',
            justifyContent: 'space-evenly',
            marginBottom: 50
        }
    }

    return (
        <div style={styles.container}>
            <motion.div
                style={styles.headingText}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                viewport={{ amount: 0.5 }}
            >
                <div>
                    <Star sx={{ fontSize: isMobile ? 20 : 30, color: 'rgb(255, 210, 48)' }} />
                    <Star sx={{ fontSize: isMobile ? 20 : 30, color: 'rgb(255, 210, 48)' }} />
                    <Star sx={{ fontSize: isMobile ? 20 : 30, color: 'rgb(255, 210, 48)' }} />
                    <Star sx={{ fontSize: isMobile ? 20 : 30, color: 'rgb(255, 210, 48)' }} />
                    <Star sx={{ fontSize: isMobile ? 20 : 30, color: 'rgb(255, 210, 48)' }} />
                </div>
                Trusted by 100+ Top Industry Brands
            </motion.div>


            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
                <div style={styles.industryBox}>
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0668/9564/2881/files/logo.jpg?v=1697093980"} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0577/5844/9753/files/web_logo_35754991-52d5-4a24-a8cb-7d2dd35cde0e.png?v=1733120743"} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0599/1831/9703/files/black_logo.webp?v=1723899623"} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0710/8103/3954/files/Beige_Minimalist_Simple_Initial_Logo_2_1.jpg?v=1727173008"} style={styles.image} ></img>
                    </div>

                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0259/7604/5664/files/RB-LOGO.png?v=1626317476"} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={VooningLogo} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0605/5798/3989/files/Qurvii_Logo_400X400_Pixels_0d08a5ca-e491-46bd-ac10-d0e47749f324-removebg-preview.png?v=1732009700"} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0903/5123/9474/files/vastrakalaa_04-01_2_1_92374559-3f19-4eef-b30f-7d4c28b9928b.jpg?v=1743958796"} style={styles.image} ></img>
                    </div>

                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0636/1464/8403/files/Twinsho-logo.png?v=1743135787"} style={styles.image} ></img>
                    </div>

                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0922/7360/6970/files/frillfit_logo_1.png?v=1738740834"} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        {/* <img src={"https://cdn.shopify.com/s/files/1/0916/8882/9250/files/Haute_Amore_Logo.png?v=1738734441"} style={styles.image} ></img> */}
                        <img src={zebra_club} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={Reena_Sharma} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0753/4546/1525/files/logo_71921d0e-795f-4b1f-916c-12dc1a7b9d5b.png?v=1724659339"} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={FashionWorldLogo} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0908/2555/6265/files/HODEE_MAIN.png?v=1737970165"} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0913/5613/5697/files/BeFunky-design_1-removebg-preview.png?v=1744976472"} style={styles.image} ></img>
                    </div>
                    
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0720/8681/4956/files/Monarch_logo.jpg?v=1724322881"} style={styles.image} ></img>
                    </div>
                    <div style={styles.gridItem}>
                        <img src={"https://cdn.shopify.com/s/files/1/0822/8189/0084/files/WhatsApp_Image_2023-08-20_at_9.36.06_AM.jpg?v=1694334773"} style={{...styles.image, width: '100%'}} ></img>
                    </div>
                </div>
            </div>
        </div >
    )
}



export default TopIndustry;